document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pv-feature-showcase]').forEach(function (root) {
    var navItems = root.querySelectorAll('[data-pv-feature-nav-item]');
    var panels = root.querySelectorAll('[data-pv-feature-panel]');
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var target = item.getAttribute('data-pv-feature-nav-item');
        navItems.forEach(function (i) { i.classList.toggle('is-active', i === item); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pv-feature-panel') === target);
        });
      });
    });
  });

  var stickyBar = document.querySelector('[data-pv-sticky-bar]');
  var hero = document.querySelector('[data-pv-hero]');
  var offer = document.querySelector('[data-pv-offer]');

  if (stickyBar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', pastHero);
      });
    }, { threshold: 0 }).observe(hero);
  }

  if (stickyBar && offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) stickyBar.classList.remove('is-visible');
      });
    }, { threshold: 0.25 }).observe(offer);
  }

  document.querySelectorAll('[data-pv-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.querySelector(btn.getAttribute('data-pv-scroll-to'));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-pv-offer-picker]').forEach(function (root) {
    var mapEl = root.querySelector('[data-pv-variant-map]');
    if (!mapEl) return;
    var variantMap;
    try {
      variantMap = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('input[name="id"]');
    var offerRoot = root.closest('[data-pv-offer]') || document;
    var priceNowEl = offerRoot.querySelector('[data-pv-offer-price-now]');
    var priceWasEl = offerRoot.querySelector('[data-pv-offer-price-was]');

    function sync() {
      var color = root.querySelector('input[name="pv_color"]:checked');
      var qty = root.querySelector('input[name="pv_qty"]:checked');
      if (!color || !qty) return;
      var variant = variantMap[color.value + ' / ' + qty.value];
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      if (priceNowEl) priceNowEl.textContent = variant.priceFormatted;
      if (priceWasEl) {
        if (variant.compareAtFormatted) {
          priceWasEl.textContent = variant.compareAtFormatted;
          priceWasEl.hidden = false;
        } else {
          priceWasEl.hidden = true;
        }
      }
    }

    root.querySelectorAll('input[name="pv_color"], input[name="pv_qty"]').forEach(function (input) {
      input.addEventListener('change', sync);
    });
    sync();
  });

  document.querySelectorAll('[data-pv-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var success = form.parentElement.querySelector('[data-pv-newsletter-success]');
      if (success) success.hidden = false;
    });
  });
});
